export const isKluwellAdmin = (role) => role === 'kluwell_admin';

export const isSchoolCoordinator = (role) => role === 'school_coordinator';

export const isTeacher = (role) => role === 'teacher';

export const isParent = (role) => role === 'parent';

export const isReader = (role) => role === 'reader';

export const isSchoolCoordinatorOrTeacher = (role) => isSchoolCoordinator(role) || isTeacher(role);

export const canEditUser = (me, user) => {
  const isMe = me.id === user.id;
  switch (me.role) {
    case 'kluwell_admin':
      return true;
    case 'school_coordinator':
      return isMe || isTeacher(user.role) || isReader(user.role);
    case 'teacher':
      return isMe || isReader(user.role);
    case 'parent':
      return isReader(user.role);
    default:
      return false;
  }
};

export const canDeleteUser = (me, user) => {
  const isNotMe = me.id !== user.id;
  switch (me.role) {
    case 'kluwell_admin':
      return isNotMe;
    case 'parent':
      return isNotMe && isReader(user.role);
    default:
      return false;
  }
};

export const canRemoveUserFromSchoolOrClassroom = (me, user) => {
  const isNotMe = me.id !== user.id;
  switch (me.role) {
    case 'kluwell_admin':
      return true;
    case 'school_coordinator':
      return isNotMe && (isTeacher(user.role) || isReader(user.role));
    case 'teacher':
      return isNotMe && isReader(user.role);
    case 'parent':
      return isNotMe && isReader(user.role);
    default:
      return false;
  }
};

export const canManageSchool = (role) => isKluwellAdmin(role) || isSchoolCoordinator(role);

export const canManageClassroom = (role) => isKluwellAdmin(role) || isSchoolCoordinator(role);
